import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("jwt");

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      setIsAuthenticated(true);
    }
  }, []);

  return isAuthenticated && <Outlet />;
};

export default ProtectedRoute;
